// removed by extract-text-webpack-plugin
module.exports = {"overlay":"_1XNWk","invisible":"_2Pd2P","backdrop":"_2DqGo","active":"_2zLGT"};


//////////////////
// WEBPACK FOOTER
// ../src/components/Overlay/Overlay.css
// module id = 496
// module chunks = 0